export default __webpack_public_path__ + "static/media/entity-coref-add-entity-mention-to-entity.b7071a0a.gif";